import "./index.scss";

/**
 * Component: Prefooter
 */
export function Prefooter() {
  console.log("Prefooter mounted.");
}
